export const skillsData = [
    {
    id: 4,
    name: "JavaScript",
    image: "./images/javascript.png",
    alt: "JavaScript"
  },
  {
    id: 5,
    name: "TypeScript",
    image: "./images/typescript.png",
    alt: "TypeScript"
  },
  {
    id: 1,
    name: "React",
    image: "./images/react.png",
    alt: "React"
  },
  {
    id: 2,
    name: "Next.js",
    image: "./images/next.png",
    alt: "Next.js"
  },
  {
    id: 3,
    name: "Node.js",
    image: "./images/node.webp",
    alt: "Node.js"
  },

  {
    id: 6,
    name: "MongoDB",
    image: "./images/mongodb.png",
    alt: "MongoDB"
  },
  {
    id: 7,
    name: "Firebase",
    image: "./images/firebase.png",
    alt: "Firebase"
  },
  {
    id: 8,
    name: "HTML",
    image: "./images/html.png",
    alt: "HTML"
  },
  {
    id: 9,
    name: "CSS",
    image: "./images/css.png",
    alt: "CSS"
  },
  {
    id: 10,
    name: "Tailwind",
    image: "./images/tailwind.png",
    alt: "Tailwind CSS"
  },
  {
    id: 11,
    name: "Bootstrap",
    image: "./images/bootstraplogo.png",
    alt: "Bootstrap"
  },
  {
    id: 12,
    name: "Redux",
    image: "./images/redux.png",
    alt: "Redux"
  },
  {
    id: 13,
    name: "Git",
    image: "./images/git.png",
    alt: "Git"
  },
  {
    id: 14,
    name: "GitHub",
    image: "./images/github.png",
    alt: "GitHub"
  }
];